import toast from 'react-hot-toast';
import { takeEvery, put, call } from 'redux-saga/effects';
import * as adminApi from '../../api/adminApi';
import * as actions from '../actions/adminActions';

export function* getGroups() {
  try {
    const groups = yield call(adminApi.getUserGroups);
    yield put(actions.getGroupsSuccess(groups));
  } catch (e) {
    yield put(actions.getGroupsFail(e.message));
    toast.error('An error occurred loading user groups.');
  }
}
export function* addUserGroup({ payload: { group } }) {
  try {
    yield call(adminApi.addUserGroup, group);
    yield put(actions.addUserGroupSuccess());
    yield put(actions.getGroups());
    toast.success('User added to group.');
  } catch (e) {
    yield put(actions.addUserGroupFail());
    toast.error('An error occurred adding a user group.');
  }
}
export function* updateUserGroup({ payload: { group } }) {
  try {
    yield call(adminApi.updateUserGroup, group);
    yield put(actions.updateUserGroupSuccess());
    yield put(actions.getGroups());
    toast.success('User group updated.');
  } catch (e) {
    yield put(actions.updateUserGroupFail());
    toast.error('An error occurred updating a user group.');
  }
}

export function* setGroup({ payload: { groupId } }) {
  try {
    yield put(actions.loadAdminData());
    yield put(actions.setGroupSuccess(groupId));
  } catch (e) {
    toast.error('An error occurred retrieving the selected organization.');
  }
}
export function* userGroupSagas() {
  yield takeEvery(actions.getGroups, getGroups);
  yield takeEvery(actions.addUserGroup, addUserGroup);
  yield takeEvery(actions.updateUserGroup, updateUserGroup);
  yield takeEvery(actions.setGroup, setGroup);
}
